import types from './types'

export const notificationAction = (id, dismiss = true) => ({ type: types.NOTIFICATION_ACTION, id, dismiss })
export const notificationHide = (id) => ({ type: types.NOTIFICATION_HIDE, id})

export const notificationsLoad = () => ({ type: types.NOTIFICATIONS_LOAD_ATTEMPT })
export const notificationsLoadSuccess = (notifications) => ({ type: types.NOTIFICATIONS_LOAD_SUCCESS,  notifications })
export const notificationsLoadFailure = (error, code) => ({ type: types.NOTIFICATIONS_LOAD_FAILURE, error, code })

export const notificationSnooze = (id, raiseTime) => ({ type: types.NOTIFICATIONS_SNOOZE_ATTEMPT, id, raiseTime })
export const notificationSnoozeSuccess = (id) => ({ type: types.NOTIFICATIONS_SNOOZE_SUCCESS,  id })
export const notificationSnoozeFailure = (error, code) => ({ type: types.NOTIFICATIONS_SNOOZE_FAILURE, error, code })

export const notificationDismiss = (id) => ({ type: types.NOTIFICATIONS_DISMISS_ATTEMPT, id })
export const notificationDismissSuccess = (id) => ({ type: types.NOTIFICATIONS_DISMISS_SUCCESS, id })
export const notificationDismissFailure = (error, code) => ({ type: types.NOTIFICATIONS_DISMISS_FAILURE, error, code })

export const notificationDismissAll = () => ({ type: types.NOTIFICATIONS_DISMISS_ALL_ATTEMPT })
export const notificationDismissAllSuccess = () => ({ type: types.NOTIFICATIONS_DISMISS_ALL_SUCCESS })
export const notificationDismissAllFailure = (error, code) => ({ type: types.NOTIFICATIONS_DISMISS_ALL_FAILURE, error, code })

export default {
  notificationAction,
  notificationHide,
  notificationLoad: notificationsLoad,
  notificationLoadSuccess: notificationsLoadSuccess,
  notificationLoadFailure: notificationsLoadFailure,
  notificationSnooze,
  notificationSnoozeSuccess,
  notificationSnoozeFailure,
  notificationDismiss,
  notificationDismissSuccess,
  notificationDismissFailure,
  notificationDismissAll,
  notificationDismissAllSuccess,
  notificationDismissAllFailure,
}
